import { render, staticRenderFns } from "./ListMotoristaResponsavelView.vue?vue&type=template&id=24e7e532&"
import script from "./ListMotoristaResponsavelView.vue?vue&type=script&lang=ts&"
export * from "./ListMotoristaResponsavelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports